export default __webpack_public_path__ + "static/media/appSvg2.c14918ee.png";